/**
 * Obliczenia dla POWYĹ»EJ24H â€“ podziaĹ‚ na KLT/GLT na podstawie arkusza POJEMNIKI.
 * Zwraca: { razem, klt, glt, najstarszaData, top5Oldest }.
 */

function getCell(row, col) {
  if (col < 0 || !row || !Array.isArray(row) || col >= row.length) return '';
  const cell = row[col];
  if (cell && typeof cell === 'object' && 'value' in cell) return cell.value != null ? String(cell.value).trim() : '';
  return cell != null ? String(cell).trim() : '';
}

function getColumnIndex(headers, name) {
  const needle = String(name || '').trim().toLowerCase();
  const idx = headers.findIndex((h) => String(h || '').trim().toLowerCase() === needle);
  return idx >= 0 ? idx : -1;
}

/** Probuje kolejne nazwy kolumn (np. rozne encodingi) i zwraca indeks pierwszej znalezionej. */
function getColumnIndexFlex(headers, ...names) {
  for (const name of names) {
    const idx = getColumnIndex(headers, name);
    if (idx >= 0) return idx;
  }
  return -1;
}

/** Normalizuje string (usunięcie akcentów) do porównania. */
function normalizeForCompare(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/** Szuka kolumny DATA PRZYJĘCIA – dokładne dopasowanie + fallback bez diakrytyków (odporne na encodingi). */
function getColumnIndexDataPrzyjecia(headers) {
  const idx = getColumnIndex(headers, 'DATA PRZYJ\u0118CIA');
  if (idx >= 0) return idx;
  const ascii = getColumnIndex(headers, 'DATA PRZYJECIA');
  if (ascii >= 0) return ascii;
  const needle = normalizeForCompare('DATA PRZYJ\u0118CIA');
  return headers.findIndex((h) => normalizeForCompare(h) === needle);
}

function parseDateFromCell(val) {
  if (val == null || val === '') return null;
  const s = String(val).trim();
  if (!s) return null;
  if (typeof val === 'number' && val > 0) {
    const d = new Date((val - 25569) * 86400 * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const datePart = s.includes(' ') ? s.split(/\s/)[0] : s;
  const iso = /^\d{4}-\d{2}-\d{2}/.exec(datePart);
  if (iso) return new Date(iso[0]);
  const ddmmyy = datePart.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})$/);
  if (ddmmyy) return new Date(parseInt(ddmmyy[3], 10), parseInt(ddmmyy[2], 10) - 1, parseInt(ddmmyy[1], 10));
  const d = new Date(datePart);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Buduje set numerĂłw pojemnikĂłw KLT z arkusza POJEMNIKI (kolumna POJEMNIK, opcjonalnie MAG). */
function buildKltSet(pojemnikiData) {
  const kltSet = new Set();
  if (!pojemnikiData || !Array.isArray(pojemnikiData) || pojemnikiData.length < 2) return kltSet;
  const headerRow = pojemnikiData[0];
  const headers = headerRow?.map((c, i) => getCell(headerRow, i)) ?? headerRow?.map((c) => (c && typeof c === 'object' ? c.value : c)) ?? [];
  const pojCol = getColumnIndex(headers, 'POJEMNIK');
  if (pojCol < 0) return kltSet;
  for (let r = 1; r < pojemnikiData.length; r++) {
    const row = pojemnikiData[r];
    const v = getCell(row, pojCol) || (row[pojCol] && typeof row[pojCol] === 'object' ? String(row[pojCol].value || '').trim() : '');
    if (v) kltSet.add(v);
  }
  return kltSet;
}

function dateToYMD(d) {
  if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Kolumna Magazyn: 902 (Przyjęcie) lub 923 (Przepak). */
function parseMagazyn902923(val) {
  const s = String(val || '').trim();
  if (!s) return null;
  if (/\b902\b/.test(s)) return '902';
  if (/\b923\b/.test(s)) return '923';
  const n = normalizeForCompare(s);
  if (n.includes('przyj')) return '902';
  if (n.includes('przepak')) return '923';
  return null;
}

/**
 * Oblicza statystyki POWYĹ»EJ24H z podziaĹ‚em na KLT/GLT.
 * Logika zgodna ze stronÄ… PrzyjÄ™cie: liczymy tylko wiersze z ostatniego wklejenia
 * (gdy kolumna DATA WPROWADZENIA DANYCH istnieje â€“ tylko batch z najnowszÄ… datÄ…).
 * @param {Array} powyzejData - surowe dane arkusza POWYĹ»EJ24H (pierwszy wiersz = nagĹ‚Ăłwki)
 * @param {Array} pojemnikiData - surowe dane arkusza POJEMNIKI (pierwszy wiersz = nagĹ‚Ăłwki)
 * @returns {{ razem: number, klt: number, glt: number, mag902: number, mag923: number, najstarszaData: Date|null, top5Oldest: Array<{snr, magazyn, date}> }}
 */
export function computePowyzej24hKltGlt(powyzejData, pojemnikiData) {
  const result = {
    razem: 0,
    klt: 0,
    glt: 0,
    mag902: 0,
    mag923: 0,
    najstarszaData: null,
    top5Oldest: [],
  };

  if (!powyzejData || !Array.isArray(powyzejData) || powyzejData.length < 2) return result;

  const headerRow = powyzejData[0];
  const headers = headerRow?.map((c) => (c && typeof c === 'object' ? c.value : c)) ?? headerRow ?? [];
  const idxSnr = getColumnIndex(headers, 'SNR');
  const idxHu = getColumnIndex(headers, 'HU');
  const idxPojemnik = getColumnIndex(headers, 'POJEMNIK');
  const idxDataPrzyjecia = getColumnIndexDataPrzyjecia(headers);
  const idxDataWprowadzenia = getColumnIndex(headers, 'DATA WPROWADZENIA DANYCH');
  const idxMagazyn = getColumnIndexFlex(headers, 'Magazyn', 'MAGAZYN');

  if (idxSnr < 0 || idxDataPrzyjecia < 0) return result;

  const kltSet = buildKltSet(pojemnikiData);
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  const dataRows = powyzejData.slice(1);

  let dataOstatniegoWklejenia = null;
  if (idxDataWprowadzenia >= 0) {
    let lastSeenYmd = null;
    dataRows.forEach((row) => {
      const wpVal = getCell(row, idxDataWprowadzenia) || (row[idxDataWprowadzenia] && typeof row[idxDataWprowadzenia] === 'object' ? row[idxDataWprowadzenia].value : row[idxDataWprowadzenia]);
      const dw = parseDateFromCell(wpVal);
      if (dw && !Number.isNaN(dw.getTime())) lastSeenYmd = dateToYMD(dw);
      if (lastSeenYmd && (!dataOstatniegoWklejenia || lastSeenYmd > dataOstatniegoWklejenia)) dataOstatniegoWklejenia = lastSeenYmd;
    });
  }

  const onlyLastPaste = dataOstatniegoWklejenia != null;
  const uniqueKeys = new Set();
  const kltKeys = new Set();
  const gltKeys = new Set();
  const keys902 = new Set();
  const keys923 = new Set();
  const bySnrMagazynOldest = new Map();
  let lastSeenYmd = null;

  dataRows.forEach((row) => {
    if (idxDataWprowadzenia >= 0) {
      const wpVal = getCell(row, idxDataWprowadzenia) || (row[idxDataWprowadzenia] && typeof row[idxDataWprowadzenia] === 'object' ? row[idxDataWprowadzenia].value : row[idxDataWprowadzenia]);
      const dw = parseDateFromCell(wpVal);
      if (dw && !Number.isNaN(dw.getTime())) lastSeenYmd = dateToYMD(dw);
    }
    const snr = getCell(row, idxSnr) || (row[idxSnr] && typeof row[idxSnr] === 'object' ? row[idxSnr].value : row[idxSnr]);
    const hu = idxHu >= 0 ? (getCell(row, idxHu) || (row[idxHu] && typeof row[idxHu] === 'object' ? row[idxHu].value : row[idxHu])) : '';
    const pojemnik = idxPojemnik >= 0 ? (getCell(row, idxPojemnik) || (row[idxPojemnik] && typeof row[idxPojemnik] === 'object' ? row[idxPojemnik].value : row[idxPojemnik])) : '';
    const dateVal = getCell(row, idxDataPrzyjecia) || (row[idxDataPrzyjecia] && typeof row[idxDataPrzyjecia] === 'object' ? row[idxDataPrzyjecia].value : row[idxDataPrzyjecia]);
    const d = parseDateFromCell(dateVal);
    if (!d || Number.isNaN(d.getTime())) return;
    if (d >= todayStart) return;

    const fromLastPaste = !onlyLastPaste || lastSeenYmd === dataOstatniegoWklejenia;
    if (!fromLastPaste) return;

    const magazyn = pojemnik && kltSet.has(String(pojemnik).trim()) ? 'KLT' : 'GLT';
    const key = `${snr}|${hu}`;

    uniqueKeys.add(key);
    if (magazyn === 'KLT') kltKeys.add(key);
    else gltKeys.add(key);

    if (idxMagazyn >= 0) {
      const magCode = parseMagazyn902923(getCell(row, idxMagazyn));
      if (magCode === '902') keys902.add(key);
      else if (magCode === '923') keys923.add(key);
    }

    const posKey = `${snr}|${magazyn}`;
    const prev = bySnrMagazynOldest.get(posKey);
    if (!prev || d < prev) bySnrMagazynOldest.set(posKey, d);
  });

  result.razem = uniqueKeys.size;
  result.klt = kltKeys.size;
  result.glt = gltKeys.size;
  result.mag902 = keys902.size;
  result.mag923 = keys923.size;

  const top5 = Array.from(bySnrMagazynOldest.entries())
    .map(([posKey, date]) => {
      const [snr, magazyn] = posKey.split('|');
      return { snr, magazyn, date };
    })
    .sort((a, b) => a.date - b.date)
    .slice(0, 5);

  result.top5Oldest = top5;
  result.najstarszaData = top5.length > 0 ? top5[0].date : null;

  return result;
}

/**
 * Zwraca peĹ‚nÄ… listÄ™ wierszy POWYĹ»EJ24H (po filtrze: data < today, ostatni batch) z kolumnÄ… MAGAZYN (KLT/GLT).
 * KaĹĽdy wiersz: { ...wartoĹ›ci kolumn z nagĹ‚ĂłwkĂłw, MAGAZYN }.
 * @param {Array} powyzejData - surowe dane arkusza POWYĹ»EJ24H
 * @param {Array} pojemnikiData - surowe dane arkusza POJEMNIKI
 * @param {boolean} sortByDateAsc - true = sortuj wg DATA PRZYJÄCIA rosnÄ…co (najstarsze first)
 * @param {boolean} onlyOldestDay - true = tylko pozycje z najstarszego dnia (dla moduĹ‚u Najstarszy)
 * @returns {{ headers: string[], rows: Array<Record<string, any>> }}
 */
export function getPowyzej24hFullRows(powyzejData, pojemnikiData, sortByDateAsc = false, onlyOldestDay = false) {
  const headers = [];
  const rows = [];
  if (!powyzejData || !Array.isArray(powyzejData) || powyzejData.length < 2) return { headers: [], rows: [] };

  const headerRow = powyzejData[0];
  const hdr = headerRow?.map((c) => (c && typeof c === 'object' ? c.value : c)) ?? headerRow ?? [];
  hdr.forEach((h, i) => { headers[i] = String(h || '').trim() || `Kolumna${i + 1}`; });
  headers.push('MAGAZYN');

  const idxSnr = getColumnIndex(hdr, 'SNR');
  const idxPojemnik = getColumnIndex(hdr, 'POJEMNIK');
  const idxDataPrzyjecia = getColumnIndexDataPrzyjecia(hdr);
  const idxDataWprowadzenia = getColumnIndex(hdr, 'DATA WPROWADZENIA DANYCH');
  if (idxSnr < 0 || idxDataPrzyjecia < 0) return { headers: [...headers.slice(0, -1)], rows: [] };

  const kltSet = buildKltSet(pojemnikiData);
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  let dataOstatniegoWklejenia = null;
  const dataRows = powyzejData.slice(1);
  if (idxDataWprowadzenia >= 0) {
    dataRows.forEach((row) => {
      const wpVal = getCell(row, idxDataWprowadzenia) || (row[idxDataWprowadzenia] && typeof row[idxDataWprowadzenia] === 'object' ? row[idxDataWprowadzenia].value : row[idxDataWprowadzenia]);
      const dw = parseDateFromCell(wpVal);
      if (dw && !Number.isNaN(dw.getTime())) {
        const ymd = dateToYMD(dw);
        if (ymd && (!dataOstatniegoWklejenia || ymd > dataOstatniegoWklejenia)) dataOstatniegoWklejenia = ymd;
      }
    });
  }

  const onlyLastPaste = dataOstatniegoWklejenia != null;
  let lastSeenYmd = null;

  dataRows.forEach((row) => {
    if (idxDataWprowadzenia >= 0) {
      const wpVal = getCell(row, idxDataWprowadzenia) || (row[idxDataWprowadzenia] && typeof row[idxDataWprowadzenia] === 'object' ? row[idxDataWprowadzenia].value : row[idxDataWprowadzenia]);
      const dw = parseDateFromCell(wpVal);
      if (dw && !Number.isNaN(dw.getTime())) lastSeenYmd = dateToYMD(dw);
    }
    const dateVal = getCell(row, idxDataPrzyjecia) || (row[idxDataPrzyjecia] && typeof row[idxDataPrzyjecia] === 'object' ? row[idxDataPrzyjecia].value : row[idxDataPrzyjecia]);
    const d = parseDateFromCell(dateVal);
    if (!d || Number.isNaN(d.getTime())) return;
    if (d >= todayStart) return;
    const fromLastPaste = !onlyLastPaste || lastSeenYmd === dataOstatniegoWklejenia;
    if (!fromLastPaste) return;

    const pojemnik = idxPojemnik >= 0 ? (getCell(row, idxPojemnik) || (row[idxPojemnik] && typeof row[idxPojemnik] === 'object' ? row[idxPojemnik].value : row[idxPojemnik])) : '';
    const magazyn = pojemnik && kltSet.has(String(pojemnik).trim()) ? 'KLT' : 'GLT';

    const rec = { _date: d };
    hdr.forEach((h, i) => {
      const v = getCell(row, i) || (row[i] && typeof row[i] === 'object' ? row[i].value : row[i]);
      rec[headers[i] || `Kolumna${i + 1}`] = v != null ? String(v) : '';
    });
    rec.MAGAZYN = magazyn;
    rows.push(rec);
  });

  if (onlyOldestDay && rows.length > 0) {
    const minDate = rows.reduce((min, r) => (!min || r._date < min ? r._date : min), null);
    const oldestYmd = minDate ? dateToYMD(minDate) : null;
    if (oldestYmd) {
      const filtered = rows.filter((r) => dateToYMD(r._date) === oldestYmd);
      rows.length = 0;
      rows.push(...filtered);
    }
  }

  if (sortByDateAsc) rows.sort((a, b) => (a._date < b._date ? -1 : a._date > b._date ? 1 : 0));
  rows.forEach((r) => delete r._date);

  return { headers: [...headers], rows };
}
